import Vue from 'vue';
import App from './App.vue';
import AOS from 'aos';
import 'aos/dist/aos.css';
import router from './router';
// import Router from 'vue-router';
import store from './store';
import MetaInfo from 'vue-meta-info';
import Swiper from 'vue-awesome-swiper';
// import { ValidationProvider } from 'vee-validate';
// 引入指令文件
import * as directives from '@/directives/index';
import elLoading from 'element-ui/packages/loading/src/directive';
// require styles
import 'swiper/dist/css/swiper.css';
import { disDevices } from './assets/scripts/dis-devices';
// 引入css
import 'element-ui/lib/theme-chalk/index.css';
// 引进Axios
import axios from 'axios';
import vueAxios from 'vue-axios';
// // 引入多语言
// import VueI18n from 'vue-i18n';
import i18n from '@/lang';

import Auth from './sdk/common/Auth';
import Cookie from 'js-cookie';
import { MapRegion } from './assets/scripts/map-region';
import { getQueryString } from './assets/scripts/common';
import { FrontE,ApiServer,ApiVersion } from '@/sdk/common/SysConst';
import { IndustryTypeArray,DistrictArray ,workTypeArray,SpecialEmploymentArray,WorkingFormsArray,WorkingStatusArray } from '@/assets/js/DataArray';
import 'animate.css';
import './assets/css/style.css';

// import * as swiperAni from 'swiper-animate';
import * as swiperAni from '@/assets/js/swiper.animate';
import 'wowjs/css/libs/animate.css'; // 此处就是wowjs中自带的animate的位置
import WOW from 'wow.js';
import infiniteScroll from 'vue-infinite-scroll';
// import ElementUI from 'element-ui';
// Vue.use(ElementUI);

// 按需引入 Element 組件，减小项目体积，可自行在 element.js 進行修改
import './plugins/element.js';
import('@/assets/css/main_m.css');
// 初始化 AOS（在挂载前）
AOS.init({
  duration: 1000,
  offset: 120,
  once: false
});
new WOW({
  boxClass: 'wow',
  animateClass: 'animate__animated',
  offset: 50,
  mobile: true,
  live: true
}).init();


// 挂载到Vue原型（单个数组）
Vue.prototype.$industryTypes = IndustryTypeArray;
Vue.prototype.$specialEmployments = SpecialEmploymentArray;
Vue.prototype.$workType = workTypeArray;
Vue.prototype.$districts = DistrictArray;
Vue.prototype.$workingForms = WorkingFormsArray;
Vue.prototype.$workingStatus = WorkingStatusArray;

// 挂载API原型
var MainapiPath: string = ApiServer + '/' + ApiVersion;
Vue.prototype.$MainapiPath = MainapiPath;
// const originalPush = Router.prototype.push;
// Router.prototype.push = function push (location) {
//   return (originalPush.call(this, location) as any).catch(err => { console.log(err); });
// };
Vue.use(elLoading);
Vue.use(MetaInfo);
Vue.use(Swiper);
Vue.use(infiniteScroll);
//  批量注册全局指令
Object.keys(directives).forEach(k => Vue.directive(k, directives[k]));
// ValidationProvider
// Vue.component('ValidationProvider', ValidationProvider);
// modified file 'node_module/_vue@2.6.10@vue/types/plugin.d.ts'
Vue.use(vueAxios, axios, i18n);
Vue.config.productionTip = false;

// 价格格式化
Vue.filter('PriceFormat', function (value) {
  if (typeof (value) === 'number') {
    return (value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'); // 保留两位小数
    // return (value || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); // 不保留小数
  }
});

Vue.prototype.$swiperAnimateCache = swiperAni.swiperAnimateCache;
Vue.prototype.$swiperAnimate = swiperAni.swiperAnimate;
Vue.prototype.$wow = WOW;

Auth.GetToken().then(() => {
  import('./init').then(async (result) => {
    Vue.use(result.default as any);

    if (FrontE.MapRegion) {
      await MapRegion();
      console.log('区分地区完成');
    }
    disDevices();
    // 向後台傳遞前台默認貨幣設置
    let currency = Vue.prototype.$Storage.get('currency') || Vue.prototype.FrontE.defaultCurrency;
    await Vue.prototype.$Api.member.setCurrency(currency).then((result) => {
      Vue.prototype.$Storage.set('currency', currency);
    }).catch((error) => {
      console.log(error);
    });
    // 獲取isPtx全局設置
    await Vue.prototype.$Api.promotion.GetHomeSeoData().then((result) => {
      localStorage.setItem('isPtx', result.Data.IsPtx);
    }).catch((error) => {
      console.log(error);
    });
  }).then(result => {
    Vue.prototype.root = new Vue({
      router,
      store,
      i18n,
      async mounted () {
        // 向後台傳遞前台默認語言設置
        let lang = i18n.locale;
        await Vue.prototype.$Api.member.setUILanguage(lang).then((result) => {
          Vue.prototype.$Storage.set('locale', lang);
        }).catch((error) => {
          console.log(error);
        });
        // setRem();
      },
      render: h => h(App)
    }).$mount('#app');
  });
}, () => { });
